<template>
  <div class="my-table">
    <div class="table-box">
      <div class="left">
        <div class="title"><span class="span">排名</span> {{ info.groupName }}</div>
        <div v-for="(team, teamIndex) in info.teamList" :key="team.id" class="team" :class="{ 'team--first': teamIndex === 0 }">
          <div class="index">{{ team.rank || '-' }}</div>
          <div class="name">
            {{ team.name }}
            <div class="name-remark" v-if="team.nameRemark">{{ team.nameRemark }}</div>
            <div class="delegation" v-if="team.delegation">{{ team.delegation }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">
          <div v-for="team in info.teamList" :key="team.id" class="vs vs-name">{{ team.name }}</div>
          <template v-if="isSpecialSportType && match && match.teamScoreOrderRule !== undefined">
            <div v-if="match.teamScoreOrderRule === 2" class="vs vs2">积分</div>
            <template v-else-if="match.teamScoreOrderRule === 1 && sportType === '网球'">
              <div class="vs vs2">胜盘</div>
              <div class="vs vs2">胜局</div>
              <div class="vs vs2">胜盘率</div>
              <div class="vs vs2">胜局率</div>
            </template>
            <template v-else>
              <div class="vs vs2">{{ winCountLabel }}</div>
              <div class="vs vs2">净胜{{ sportType === '网球' ? '盘' : '局' }}</div>
              <div class="vs vs2">净胜{{ sportType === '网球' ? '局' : '分' }}</div>
            </template>
          </template>
          <template v-else>
            <div class="vs vs2">{{ winCountLabel }}</div>
            <div class="vs vs2">净胜{{ sportType === '网球' ? '盘' : '局' }}</div>
            <div class="vs vs2">净胜{{ sportType === '网球' ? '局' : '分' }}</div>
          </template>
        </div>
        <div v-for="(team1, i) in info.teamList" :key="team1.id" class="team">
          <div v-for="(team2, j) in info.teamList" :key="team2.id" class="vs" :class="{
            'no-game': team1.id === team2.id,
            'has-score': getScoreClass(team1, team2).hasScore,
            'is-winner': getScoreClass(team1, team2).isWinner
          }" @click="goDetail(team1, team2, i, j)">
            {{ getScore(team1, team2) }}
            <img :src="mp4" v-if="getGameStatus(team1, team2) === 'mp4'" />
            <img :src="live" v-else-if="getGameStatus(team1, team2) === 'live'" />
          </div>
          <template v-if="isSpecialSportType && match && match.teamScoreOrderRule !== undefined">
            <div v-if="match.teamScoreOrderRule === 2" class="vs vs2">{{ team1.totalScore || 0 }}</div>
            <template v-else-if="match.teamScoreOrderRule === 1 && sportType === '网球'">
              <div class="vs vs2">{{ team1.winGameStageCount || 0 }}</div>
              <div class="vs vs2">{{ team1.winScoreCount || 0 }}</div>
              <div class="vs vs2">
                {{ team1.winGameStageCount }} / {{ team1.winGameStageCount + team1.loseGameStageCount }}
                <br />
                <span style="font-size: 10px;color: #999;margin-top: 2px;">{{ getScoreRate(team1.gameStageWinRate) }}</span>
              </div>
              <div class="vs vs2">
                {{ team1.winScoreCount }} / {{ team1.winScoreCount + team1.loseScoreCount }}
                <br />
                <span style="font-size: 10px;color: #999;margin-top: 2px;">{{ getScoreRate(team1.scoreWinRate) }}</span>
              </div>
            </template>
            <template v-else>
              <div class="vs vs2">{{ team1.winRound }}</div>
              <div class="vs vs2">{{ team1.netWinGameStageCount }}</div>
              <div class="vs vs2">{{ team1.netWinScoreCount }}</div>
            </template>
          </template>
          <template v-else>
            <div class="vs vs2">{{ team1.winRound }}</div>
            <div class="vs vs2">{{ team1.netWinGameStageCount }}</div>
            <div class="vs vs2">{{ team1.netWinScoreCount }}</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    gameList: {
      type: Array,
      default: () => []
    },
    sportType: {
      type: String,
      default: ''
    },
    match: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mp4: 'https://images.snsports.cn/FuLkSv4qR0RynUd9u0wOq-9oA-dO',
      live: 'https://images.snsports.cn/FpZC7H9t4rYk2Lr5xJZ1_Rn8bJm1'
    }
  },
  computed: {
    isSpecialSportType() {
      return ['乒乓球', '羽毛球', '网球'].includes(this.sportType)
    },
    winCountLabel() {
      return this.sportType === '网球' ? '胜次' : '胜场'
    }
  },
  methods: {
    getScoreClass(team1, team2) {
      if (team1.id === team2.id) {
        return { hasScore: false, isWinner: false }
      }

      const game = this.info.gameList.find(game =>
        (game.homeTeamId === team1.id && game.awayTeamId === team2.id) ||
        (game.homeTeamId === team2.id && game.awayTeamId === team1.id)
      )

      if (!game) {
        return { hasScore: false, isWinner: false }
      }

      const score1 = game.homeTeamId === team1.id ? game.homeScore : game.awayScore
      const score2 = game.homeTeamId === team1.id ? game.awayScore : game.homeScore

      return {
        hasScore: true,
        isWinner: score1 > score2
      }
    },
    getScore(team1, team2, row) {
      if (team1.id === team2.id) {
        return ''
      }

      const game = this.info.gameList.find(game =>
        (game.homeTeamId === team1.id && game.awayTeamId === team2.id) ||
        (game.homeTeamId === team2.id && game.awayTeamId === team1.id)
      )

      if (!game || (game.homeScore < 0 && game.homeScore < 0)) {
        return '未开赛'
      }

      if (row === 0) {
        return game.homeTeamId === team1.id
          ? `${game.homeScore}-${game.awayScore}`
          : `${game.awayScore}-${game.homeScore}`
      }

      return game.homeTeamId === team1.id
        ? `${game.homeScore}-${game.awayScore}`
        : `${game.awayScore}-${game.homeScore}`
    },
    goDetail(team1, team2) {
      if (team1.id === team2.id) {
        return
      }

      const game = this.info.gameList.find(game =>
        (game.homeTeamId === team1.id && game.awayTeamId === team2.id) ||
        (game.homeTeamId === team2.id && game.awayTeamId === team1.id)
      )
      if (!game) return
      if ((game.awayScore > -1 && game.homeScore > -1) || (this.getGameStatus(team1, team2) !== '')) {
        this.$router.push(`/game/${game.id}/data`)
      }
    },
    getGameStatus(team1, team2) {
      if (team1.id === team2.id) return ''

      const game = this.info.gameList.find(game =>
        (game.homeTeamId === team1.id && game.awayTeamId === team2.id) ||
        (game.homeTeamId === team2.id && game.awayTeamId === team1.id)
      )

      if (!game || game.livePublic !== 1 || !game.liveStatus) return ''

      if (game.liveStatus.status === 2) return 'mp4'
      if (game.liveStatus.status === 1) return 'live'

      return ''
    },
    getScoreRate(value) {
      if (value === null || value === undefined || value === '') {
        return '0%'
      }

      const numValue = Number(value)

      if (isNaN(numValue) || !isFinite(numValue)) {
        return '0%'
      }

      const clampedValue = Math.max(0, Math.min(10000, numValue))
      const percentage = (clampedValue / 100).toFixed(2)
      const formattedPercentage = percentage.endsWith('.00')
        ? percentage.replace('.00', '')
        : percentage

      return `${formattedPercentage}%`
    }
  }
}
</script>

<style scoped lang="scss">
.my-table {
  margin-bottom: 12px;

  .table-box {
    display: flex;
    width: 100%;
    background: #fff;

    .left {
      min-width: 120px;
      width: 120px;
      font-size: 12px;
      font-weight: 500;
      flex-shrink: 0;

      .title {
        height: 58px;
        line-height: 58px;
        text-align: center;
        background: #337ECC;
        color: #fff;
        margin-bottom: 1px;
        padding-left: 24px;
        box-sizing: border-box;
        position: relative;
        font-weight: 600;

        .span {
          position: absolute;
          left: 0;
          width: 24px;
          height: 100%;
          border-right: 1px solid rgba(255, 255, 255, 0.35);
          line-height: 1.1;
          display: flex;
          align-items: center;
          justify-content: center;
          writing-mode: vertical-rl;
          font-size: 11px;
          letter-spacing: 2px;
          background: #2B6CB0;
        }
      }

      .team {
        height: 58px;
        min-height: 58px;
        text-align: center;
        background: #7EB8EC;
        color: #fff;
        margin-bottom: 1px;
        display: flex;

        &.team--first {
          background: #6FAFE8;
        }

        &:last-child {
          height: 60px;
          margin-bottom: 0;
        }

        .index {
          width: 24px;
          line-height: 58px;
          text-align: center;
          border-right: 1px solid rgba(255, 255, 255, 0.35);
          background: #337ECC;
          font-weight: 600;
        }

        .name {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-weight: 600;
          line-height: 1.3;

          .delegation {
            display: inline;
            font-size: 10px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.88);
            margin-top: 2px;
          }

          .name-remark {
            font-size: 10px;
            font-weight: 400;
            margin-top: 2px;
            color: rgba(255, 255, 255, 0.88);
          }
        }
      }
    }

    .right {
      flex: 1;
      overflow-x: auto;
      min-width: 0;
      margin-left: 1px;

      .title {
        display: flex;
        margin-bottom: 1px;

        .vs:not(:last-child) {
          margin-right: 1px;
        }

        .vs {
          min-width: 80px;
          width: 80px;
          height: 58px;
          line-height: 58px;
          text-align: center;
          background: #ECF5FF;
          font-size: 12px;
          font-weight: 500;
          color: #606266;
        }

        .vs2 {
          background: #E3F0FA;
          color: #606266;
        }
      }

      .team {
        display: flex;
        margin-bottom: 1px;

        .vs:not(:last-child) {
          margin-right: 1px;
        }

        &:last-child {
          margin-bottom: 0;
        }

        .vs {
          min-width: 80px;
          width: 80px;
          height: 60px;
          text-align: center;
          background: #F3F3F3;
          position: relative;
          font-size: 12px;
          color: #909399;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          img {
            width: 12px;
            height: 12px;
            margin-top: 4px;
          }

          &.has-score {
            font-weight: 600;
            color: #303133;
          }

          &.is-winner {
            color: #303133;
            font-weight: 600;
          }

          &.no-game {
            background: #D8D8D8;

            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: linear-gradient(to right top, transparent calc(50% - 1px), #A8A8A8, transparent calc(50% + 1px));
            }
          }
        }

        .vs-name {
          font-size: 10px;
        }

        .vs2 {
          font-weight: 600;
          color: #303133;
          background: #F3F3F3;
        }
      }

      &::-webkit-scrollbar {
        display: none;
      }

      scrollbar-width: none;
      -ms-overflow-style: none;
    }
  }
}
</style>
